import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import ModalX from '../../../../../common/svgs/ModalX';
import { RetrievalButton } from '../../../../../common/components/c_SourceSimpleFileInput';
import { isEmpty } from 'lodash';

@connect((state) => {
  return {
    documents: state.jobRequestDocuments.documents,
    profileId: state.jobRequest.primaryContactId
  }
})
export default class JobRequestDocuments extends Component {

  static propTypes = {
    documents: PropTypes.object.isRequired,
    closeDocuments: PropTypes.func.isRequired,
    profileId: PropTypes.number.isRequired
  };


  renderDocument = (document) => {
    
      return (
        <RetrievalButton
          className='file-get'
          loadingClass=''
          notLoadingClass=''
          failureClass=''
          autoLoad
          noMessage
          path={document.storagePath}
          signingRoute='/api/s3/get-sign'
        >
          <div  className='document-container'>
            <div className='document-name'>{document.fileName}</div>
            <div className='document-desc-container'>
              <div className='document-desc'>{document.description}</div>
              <div className='document-filesize'> {`${Math.max(Math.round(document.fileSize/100000)/10, 0.1)} Mgb`}</div>
            </div>
          </div>
        </RetrievalButton>
      );
  }
  render() {

    return (
      <div className='job-request-worksheet-documents'>
        <div className='job-request-worksheet-documents-container'>
        <h1 className='heading'>Available Documents <ModalX onClick={this.props.closeDocuments } style={{color: '#000'}} className='close-button' /></h1>

          { !isEmpty(this.props.documents) ?
              this.props.documents.map((document) => this.renderDocument(document)  ) 
              :
              <p>No Documents Have Been Uploaded Yet</p>
          }
          
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/Documents/index.js